import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { ClientRooftopView } from './';
import { HelpBlock, FormGroup, FormControl, ControlLabel, Panel, Accordion } from 'react-bootstrap';
import Select from 'react-select';
import Dropzone from 'react-dropzone';
import { FieldList } from '../';

class NewDamageIncidentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      storm: null,
      damage_level: null,
      material_type: null,
      description: '',
      files: [],
      adjuster: null,
      client: null,
      creator: null,
      saved: false
    };

    this.onOptionSelect = this.onOptionSelect.bind(this);
    this.onDescriptionChange = this.onDescriptionChange.bind(this);
    this.onSaveIncident = this.onSaveIncident.bind(this);
    this.onAdjusterChange = this.onAdjusterChange.bind(this);
  }

  componentWillMount() {
    this.setState({ client: this.props.client._id, creator: this.props.user._id });
  }

  onOptionSelect(val) {
    let copyState = this.state;

    copyState[val.type] = val.value;

    this.setState(copyState);
  }

  onAdjusterChange(event) {
    this.setState({ adjuster: event.target.value });
  }

  onDescriptionChange(event) {
    const description = event.target.value;

    this.setState({ description });
  }

  onSaveIncident(e) {
    this.props.sendSocketEmit(this.state, 'client-incident-new');
  }

  render() {
    const damageLevels = ['Light', 'Moderate', 'Severe'].map((level, idx) => {
      return { value: level, label: level, type: 'damage_level' }
    });

    const materialTypes = ['Asphalt', 'Composition', 'Rolled', 'Metal', 'Tile', 'Slate'].map((material, idx) => {
      return { value: material, label: material, type: 'material_type' };
    });

    const impacts = this.props.client_incidents.recent_impacts;

    const stormOptions = (impacts) ?
      impacts.map((impact, idx) => {
        const storm_date = moment(impact.properties.storm_date).format('MM-DD-YYYY');
        return { value: impact._id, label: `${storm_date} - ${impact.properties.title}`, type: 'storm' };
      }) : [];

    return (
      <div>
        <div className="row">
          <div className="col-xs-4">
            <FormGroup controlId="formControlsSelect1">
              <ControlLabel>Damage Level</ControlLabel>
              <Select
                name="damage"
                value={this.state.damage_level}
                options={damageLevels}
                onChange={this.onOptionSelect}
              />
            </FormGroup>
            <FormGroup controlId="formControlsSelect2">
              <ControlLabel>Material Type</ControlLabel>
              <Select
                name="material"
                value={this.state.material_type}
                options={materialTypes}
                onChange={this.onOptionSelect}
              />
            </FormGroup>
            <FormGroup controlId="formControlsSelect3">
              <ControlLabel>Select Storm</ControlLabel>

              <Select
                name="storm"
                value={this.state.storm}
                isLoading={!this.props.client_incidents.recent_impacts.length}
                options={stormOptions}
                onChange={this.onOptionSelect}
              />
            </FormGroup>
            <FieldGroup
              id="adjuster"
              type="text"
              label="Adjuster"
              placeholder="Adjuster name"
              onChange={this.onAdjusterChange}
            />
          </div>
          <div className="col-xs-8">
            <ClientRooftopView client={this.props.client}/>
          </div>
        </div>

        <div className="row">
          <hr />
          <div className="col-xs-12">
            <FormGroup controlId="incidentSelect">
              <ControlLabel>Incident Description</ControlLabel>
              <textarea value={this.state.description} onChange={this.onDescriptionChange} cols="50" className="form-control"></textarea>
            </FormGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <p className="pull-right">
              <strong>* Note: </strong> Additional information can be entered once a damage incident has been created.
            </p>
          </div>
        </div>

        <div className="row">
          <hr />
          <div className="col-xs-12">
            <div onClick={this.onSaveIncident} className="btn btn-lg btn-primary col-xs-12">Create & Review</div>
          </div>
        </div>

      </div>
    );
  }
}

const FieldGroup = ({ id, label, help, ...props }) => {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

NewDamageIncidentForm.propTypes = {
  client: PropTypes.object.isRequired,
}

const mapStateToProps = ({ client_incidents, client, connection }) => ({ client_incidents, client, user: connection.user });

export default connect(mapStateToProps, Actions)(NewDamageIncidentForm);



// WEBPACK FOOTER //
// ./src/browser/components/client/new-damage-incident-form.js